import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const PinLocationMap1 = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M15.0012 3.00626V8.99875" />
      <path d="M8.99875 4.777V19.0029" />
      <path d="M21.0037 9.99917V5.61034C21.0037 5.17916 20.7276 4.79701 20.3195 4.66095L15.6335 3.0993C15.2213 2.96224 14.7772 2.96224 14.365 3.0993L9.63101 4.67696C9.21984 4.81401 8.77666 4.81401 8.36549 4.67696L4.3128 3.32639C3.66553 3.1103 2.99625 3.5925 2.99625 4.27579V15.6195C2.99625 15.9987 3.21034 16.3458 3.54948 16.5149L8.10438 18.7918C8.66761 19.074 9.33089 19.073 9.89412 18.7918L12 17.7384" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.195 20.7226C18.8088 21.0978 18.1976 21.0978 17.8114 20.7226C16.79 19.7312 15.0013 17.7264 15.0013 15.8496C15.0013 13.9158 16.5689 12.3481 18.5027 12.3481C20.4365 12.3481 22.0042 13.9158 22.0042 15.8496C22.0042 17.7264 20.2154 19.7312 19.195 20.7226Z"
      />
      <path d="M18.5017 15.4865C18.3576 15.4865 18.2416 15.6035 18.2426 15.7466C18.2426 15.8906 18.3596 16.0067 18.5027 16.0067C18.6458 16.0067 18.7628 15.8896 18.7628 15.7466C18.7628 15.6025 18.6468 15.4865 18.5017 15.4865" />
    </svg>
  );
};
